<template>
	<div>我是主页</div>
</template>

<script type="text/javascript">
	export default{
		data() {
			return {
				
			}
		},
		mounted() {
			// this.test()
		},
		methods:{
			
		}
	}
</script>

<style>
</style>